import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoginService } from 'src/app/Services/login.service';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'ppa-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @BlockUI() blockUi: NgBlockUI;
  administrador = false;
  constructor(private router: Router, private loginService: LoginService) { }

  ngOnInit() {
  }

  logout() {

    //this.blockUi.start('Redirecionando...');
    setTimeout(() => {
      this.router.navigate(['public']);
      }, 800)

    // this.blockUi.start('Processando sua pesquisa...');
    // this.loginService.logout();
    // this.router.navigate(['publico']);
   
  }
}
